export function setRefreshRecordList(func) {
	return {
		type: 'SET_REFRESH_EMPLOYEE_LIST',
		func
	}
}